// <head> metadata for BlogPage (https://www.dbos.dev/blog).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Blog | DBOS',
    },
    {
      name: 'description',
      content:
        'Articles on durable execution, durable workflows and Postgres, with Python, TypeScript, Go and Java examples, plus DBOS product updates.',
    },
    {
      property: 'og:title',
      content: 'Blog | DBOS',
    },
    {
      property: 'og:description',
      content:
        'Articles on durable execution, durable workflows and Postgres, with Python, TypeScript, Go and Java examples, plus DBOS product updates.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Blog | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'Articles on durable execution, durable workflows and Postgres, with Python, TypeScript, Go and Java examples, plus DBOS product updates.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/blog',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
